import React from 'react'
import { Col, Container } from 'react-bootstrap';
import { Box, Briefcase, Globe, Users } from 'react-feather';
import { Button, Row } from 'reactstrap';

function FooterBottom() {
  return (
    <div>
      <footer className="footer">
        <Container>
          <Row>
            <Col
             lg={4} md={6}>
              <div className="footer-about">
                <h5>OlewinTechSolutions</h5>
                <p>
                  A leading technology company providing innovative solutions in blockchain, AI, e-commerce, and software development for diverse industries worldwide.
                </p>
                <div className="social-icons">
                  <a href="/"><Box size={20} /></a>
                  <a href="/"><Users size={20} /></a>
                  <a href="/"><Briefcase size={20} /></a>
                  <a href="/"><Globe size={20} /></a>
                </div>
              </div>
            </Col>
            <Col lg={2} md={6}>
              <div className="footer-links">
                <h5>Services</h5>
                <ul>
                  <li><a href="/">Blockchain</a></li>
                  <li><a href="/">AI Solutions</a></li>
                  <li><a href="/">Web Apps</a></li>
                  <li><a href="/">Mobile Apps</a></li>
                  <li><a href="/">E-commerce</a></li>
                </ul>
              </div>
            </Col>
            <Col lg={2} md={6}>
              <div className="footer-links">
                <h5>Company</h5>
                <ul>
                  <li><a href="/">About Us</a></li>
                  <li><a href="/">Team</a></li>
                  <li><a href="/">Careers</a></li>
                  <li><a href="/">Blog</a></li>
                  <li><a href="/">Contact</a></li>
                </ul>
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div className="footer-newsletter">
                <h5>Stay Updated</h5>
                <p>Subscribe to our newsletter for the latest updates and insights.</p>
                <div className="newsletter-form">
                  <input type="email" placeholder="Your email address" />
                  <Button color="primary">Subscribe</Button>
                </div>
              </div>
            </Col>
          </Row>
          <hr />
          <div className="footer-bottom">
            <p>&copy; 2021 - 2025 OlewinTechSolutions. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="/">Privacy Policy</a>
              <a href="/">Terms of Service</a>
              <a href="/">Cookie Policy</a>
            </div>
          </div>
        </Container>
      </footer>
    </div>
  )
}

export default FooterBottom;
